import { render, staticRenderFns } from "./MenuIndex.vue?vue&type=template&id=ca5e4742"
import script from "./MenuIndex.vue?vue&type=script&lang=js"
export * from "./MenuIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports